import React, { useState, useEffect } from 'react';
import MenuNav from './MenuNav';
import { FaRegBell, FaBars, FaTimes, FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { apiService } from '../../components/Config/api.service';
import yrosLogo from '../../assets/yros_logo.png';

const SidebarNav = ({ isOpen: initialIsOpen, isCollapsed, setIsCollapsed, onLogoutRequest }) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen || false);
  const [companies, setCompanies] = useState([]);
  const [multicompany, setMulticompany] = useState(false);
  const [activeCompanyId, setActiveCompanyId] = useState(null);
  const [activeCompanyName, setActiveCompanyName] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  const isConnected = localStorage.getItem('isConnected');

  useEffect(() => {
    // Charger la préférence de l'utilisateur pour la sidebar
    const sidebarState = localStorage.getItem('sidebarCollapsed');
    if (sidebarState) {
      setIsCollapsed(sidebarState === 'true');
    }
    
    const fetchCompanies = async () => {
      try {
        const response = await apiService.getElement('/user');
        const user = response.data.user;
        localStorage.setItem('user', JSON.stringify(user));
        setMulticompany(user.multicompany);
        setCompanies(user.company_ids);
        setActiveCompanyId(user.company_active.id);
        setActiveCompanyName(user.company_active.name);
      } catch (error) {
        console.error('Erreur lors de la récupération des sociétés :', error);
      }
    };

    if (isConnected) {
      fetchCompanies();
    }
  }, [isConnected]);

  // Fonction pour basculer l'état de la sidebar
  const toggleSidebar = () => {
    const newState = !isCollapsed;
    setIsCollapsed(newState); // Ça mettra à jour l'état dans App.js
    localStorage.setItem('sidebarCollapsed', newState.toString());
  };

  const handleCompanyChange = async (newCompanyId) => {
    try {
      const response = await apiService.saveElement(`/switch_company/${newCompanyId}`, {});
      const { active_company_name, active_company_id, companies } = response.data;

      
      setActiveCompanyId(active_company_id);
      setActiveCompanyName(active_company_name);
      setCompanies(companies);
      localStorage.setItem('companyName', active_company_name);
      setShowDropdown(false);
      window.location.reload(); 
    } catch (error) {
      console.error('Erreur lors du changement de société :', error);
    }
  };

  if (!isConnected) {
    return null;
  }

  return (
    <div>
      <div className="lg:hidden flex justify-between px-4 z-50 cursor-pointer">
        <button className="" onClick={() => setIsOpen(true)}>
          {isOpen ? <FaTimes className="text-white" size={24} /> : <FaBars className="text-[--color-primary]" size={24} />}
        </button>
        <div className="flex gap-2 items-center p-4">
          <button onClick={() => setIsOpen(true)} className="text-3xl text-[--color-primary] font-extrabold">
            {activeCompanyName}
          </button>
          <FaRegBell className="text-2xl text-[--color-primary] font-extrabold" />
        </div>
      </div>

      <div
        className={`fixed top-0 left-0 bottom-0 bg-[--color-primary] z-50 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-all duration-300 ease-in-out lg:translate-x-0 flex flex-col ${
          isCollapsed ? 'w-[70px]' : 'w-[250px]'
        } overflow-hidden`}
      >
        {/* Header: company + logo */}
        <div className="hidden lg:block cursor-pointer">
          <div className="flex justify-between items-center p-4 relative">
            <div className="flex items-center gap-2">
              <div className="text-center py-4 text-white font-bold">
                <img src={yrosLogo} alt="Logo" className="w-12 h-12 mx-auto bg-[--color-orange] rounded-lg" />
              </div>
              {!isCollapsed && (
                <span
                  className="text-3xl text-white font-bold"
                  onClick={() => 
                    // afficher le menu déroulant pour changer de société que si multicompany a true
                    multicompany && setShowDropdown(!showDropdown)}
                >
                  {activeCompanyName}
                </span>
              )}
            </div>

            {showDropdown && !isCollapsed && (
              <div className="absolute top-full left-2 mt-2 bg-white shadow-lg rounded w-[90%] z-10">
                <div className="p-2 text-gray-700 text-center font-semibold">Changer de société</div>
                {companies.map((company) => (
                  <div
                    key={company.id}
                    className={`p-2 cursor-pointer hover:bg-gray-200 ${
                      company.id === activeCompanyId ? 'font-bold text-[--color-primary]' : ''
                    }`}
                    onClick={() => handleCompanyChange(company.id)}
                  >
                    {company.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Scrollable menu (takes remaining height) */}
        <div className="flex-1 text-center overflow-y-auto mt-4">
          <MenuNav isCollapsed={isCollapsed} onLogoutRequest={onLogoutRequest} />
        </div>

        {/* Footer / toggle (remains visible) */}
        <div className="hidden lg:flex justify-end p-4">
          <button
            onClick={toggleSidebar}
            className="bg-[--color-orange] text-white rounded-full p-2 hover:bg-orange-500 transition-colors"
          >
            {isCollapsed ? <FaAngleRight /> : <FaAngleLeft />}
          </button>
        </div>
      </div>

      {/* Overlay pour fermer la barre latérale sur mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default SidebarNav;